import Vue from "vue";
import router from "./router";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";
import "./assets/css/element-variables.scss";
import App from "./App.vue";
import VueFilterDateFormat from "@vuejs-community/vue-filter-date-format";
import store from "./store";
import "nouislider/distribute/nouislider.css";
import Notifications from "vue-notification";
import "normalize.css";


Vue.config.productionTip = false;

Vue.use(ElementUI, { locale });
Vue.use(VueFilterDateFormat);
Vue.use(Notifications);

new Vue({
  router,
  render: h => h(App),
  store: store
}).$mount("#app");
